import { fmtPct } from "../../services/retroFormatters";

function tone(status) {
  if (status === "done") return "green";
  if (status === "on_track") return "green";
  if (status === "in_flight") return "amber";
  return "red";
}

export default function GoalsCard({ goals = [] }) {
  return (
    <div className="rtv2-card">
      <div className="rtv2-card-head">
        <div>
          <h3>Goals <em>— Q1 cycle</em></h3>
          <span className="sub">{goals.length} set</span>
        </div>
      </div>
      <div className="rtv2-goals-list">
        {goals.map((g) => (
          <div className={`rtv2-goal ${tone(g.status)}`} key={g.code}>
            <div className="left">
              <span className="id">{g.code}</span>
              <h4>{g.title}</h4>
            </div>
            <div className="right">
              <b>{fmtPct(g.progress)}</b>
              <div className="bar"><i style={{ width: fmtPct(g.progress) }} /></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
